import { useApiKey } from 'hooks/ApiKey';
import ApiKeyItem from './ApiKeyItem';
import styles from './index.module.scss';
import Typography from 'components/Typography';
import { useMemoTranslations } from 'hooks/Intl';
import * as translations from 'intls/apiKey';

const ApiKeyList = () => {
  const { apiKeys } = useApiKey();
  const intl = useMemoTranslations(translations);

  return (
    <div className={styles.container}>
      {apiKeys.length === 0 && (
        <Typography>{intl.NO_API_KEYS_CREATED_FOR_THIS_PARTNER}</Typography>
      )}
      {apiKeys.map(apiKey => (
        <ApiKeyItem apiKey={apiKey} key={apiKey.api_key_id} />
      ))}
    </div>
  );
};

export default ApiKeyList;
